import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import PolicyTermTable from "./PolicyTermTable";

const PolicyTerm = () => {
  const viewPermission = PERMISSIONS.permission_utilities_policyterm_terms_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) && <PolicyTermTable />}</>
  );
};

export default PolicyTerm;
